<template>
  <v-dialog v-model="dialog" width="550" scrollable>
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        depressed
        class="primary"
        tile
        :width="is_mobile ? '' : '103px'"
        color="white"
        :height="$root.dense ? '40px' : '56px'"
      >
        CMP
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="d-flex align-center">
        {{ title }}
        <v-spacer></v-spacer>
        <create></create>
      </v-card-title>
      <v-card-text class="pb-0 pt-3">
        <v-autocomplete
          v-model="cmp"
          item-text="name"
          return-object
          dense
          :items="items"
          outlined
          label="Search and Select CMP"
        ></v-autocomplete>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="red" @click="dialog = false">Cancel</v-btn>
        <v-btn text color="green" @click="submit()">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Create from "../../cmp/Create.vue";
export default {
  components: { Create },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    phone: {
      default: ""
    }
  },
  data() {
    return {
      dialog: false,
      cmp: {}
    };
  },
  computed: {
    title() {
      return "Search CMP";
    },
    items() {
      let list = this.$store.getters.cmp.map(item => {
        let { address, zipcode, landmark } = item;
        zipcode = this.getZip(item);
        item.name = `${landmark}, ${address}, ${zipcode}`;
        return item;
      });
      return list.sort((a, b) => a.name.localeCompare(b.name));
    }
  },
  methods: {
    getZip({ zipcode }) {
      let zipcodes = this.$store.getters.zipcodes;
      let item = zipcodes.find(item => {
        return item.id == zipcode;
      });
      return item != null ? item.zipcode : "";
    },

    submit() {
      this.$emit("onCMPSelect", this.cmp);
      this.dialog = false;
    }
  }
};
</script>

<style></style>
